// extracted by mini-css-extract-plugin
module.exports = {"select-group":"select-group","btn-select":"btn-select","select-text":"select-text","icon":"icon","group-items":"group-items","group-item":"group-item","is-select":"is-select"};